var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.84,
    y: 0.78,
    width: 21.38,
    height: 29.44,
    rx: 3.12,
    fill: "#fff",
    stroke: "#adb8be",
    strokeWidth: 1.56
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5,14H18.92a2.5,2.5,0,0,1,2.49,2.5v6.63a2.48,2.48,0,0,1-2.49,2.49H2.5A2.48,2.48,0,0,1,0,23.14V16.45A2.5,2.5,0,0,1,2.5,14Z",
    fill: "#e5005d",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.67,22.47V20.31h.55a2.53,2.53,0,0,0,1.72-.52,1.88,1.88,0,0,0,.61-1.5A1.73,1.73,0,0,0,7,16.87a2.53,2.53,0,0,0-1.66-.48H3.4v6.08Zm.42-3.22H4.67v-1.8h.58a1.17,1.17,0,0,1,.77.21.87.87,0,0,1,.24.67A.84.84,0,0,1,6,19a1.44,1.44,0,0,1-.88.23Zm5.29,3.22a3.39,3.39,0,0,0,2.44-.8,3,3,0,0,0,.84-2.3,2.91,2.91,0,0,0-.81-2.19,3.11,3.11,0,0,0-2.28-.79H8.68v6.08Zm.12-1.06H10v-4h.68c1.14,0,1.71.65,1.71,2S11.73,21.41,10.5,21.41Zm5.66,1.06v-2.4h2V19h-2V17.45h2.19V16.39H14.91v6.09h1.25Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.38e00f879f3ec8f21c3588e5e3d8f4d7.svg";
export { ForwardRef as ReactComponent };